const upload_url = (customer, locationId) => `get-upload-url/${customer}/${locationId}`;
const save_url = (customer, locationId, mission) =>
  `save-file-url/${customer}/${locationId}/${mission}`;
const get_missions = (customer, locationId) => `get-missions/${customer}/${locationId}`;
const get_mission_files = (customer, locationId, missionId) =>
  `get-mission-files/${customer}/${locationId}/${missionId}`;
const delete_file = (customer, locationId, mission) =>
  `delete-file/${customer}/${locationId}/${mission}`;
const delete_mission = (customer, locationId, mission) =>
  `delete-mission/${customer}/${locationId}/${mission}`;
const run_mission = (customer, locationId, mission) =>
  `run-mission/${customer}/${locationId}/${mission}`;
const get_plants = () => 'modelregistry/plants/user';
const get_subscription_crops = () => 'subscriptions/user';
export const uploadEndpoints = {
  upload_url,
  save_url,
  get_missions,
  get_mission_files,
  delete_file,
  delete_mission,
  run_mission,
  get_plants,
  get_subscription_crops
};
